import { LoadingSkeleton } from "@asayinc/component-library";
import { Box, SxProps } from "@mui/material";
import {
  AccountBalanceOutlined,
  AccountCircleOutlined,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import {
  SearchResult,
  SearchSecurity,
  SearchCustomer,
} from "src/store/globalSearch/types";
import { SearchRow } from "../SearchRow";

interface ISearchResultsProps {
  isLoading: boolean;
  options: SearchResult[] | undefined;
  leftHeader: string;
  rightHeader: string;
  toCustomer?: boolean;
  onClose?: () => void;
  sx?: SxProps;
}

export function SearchResults({
  isLoading,
  options,
  leftHeader,
  rightHeader,
  toCustomer = true,
  sx,
  onClose,
}: ISearchResultsProps) {
  const navigate = useNavigate();

  if (!isLoading && options?.length === 0) {
    return null;
  }

  return (
    <Box sx={sx}>
      <SearchRow
        leftContent={leftHeader}
        rightContent={rightHeader}
        isRightBold={false}
      />
      {isLoading && (
        <SearchRow
          leftContent={<LoadingSkeleton />}
          rightContent={
            <LoadingSkeleton sx={{ width: "50%", float: "right" }} />
          }
        />
      )}
      {!isLoading &&
        options?.map((option, key) => {
          const handleOnClick = () => {
            if (toCustomer) {
              navigate(`/customers/${option.id}/mailings`);
            } else {
              navigate(
                `/issuers/${(option as SearchSecurity).issuerId}/proxy-events`
              );
            }
            onClose?.();
          };

          const leftValue = toCustomer
            ? option.matchingValue
            : (option as SearchSecurity).ticker;
          const rightValue = toCustomer
            ? `${(option as SearchCustomer).firstName} ${
                (option as SearchCustomer).lastName
              }`.trim()
            : (option as SearchSecurity).issuerName;

          return (
            <SearchRow
              key={key}
              onClick={handleOnClick}
              leftContent={leftValue}
              rightContent={rightValue}
              rightIcon={
                toCustomer ? (
                  <AccountCircleOutlined sx={{ ml: 2 }} />
                ) : (
                  <AccountBalanceOutlined sx={{ ml: 2 }} />
                )
              }
            />
          );
        })}
    </Box>
  );
}
